import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { createTheme } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { Box, InputAdornment } from '@mui/material';
import TextField from '@mui/material/TextField';
import { useEffect, useState } from 'react';
import { prefixer } from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';

import { useSelector } from 'react-redux';
import { IShellConfig } from '../../models/IShellConfig';
import { RootState } from '../../redux/store';
import { ITextField } from './ITextField';

const cacheRtl = createCache({
    key: 'muirtl',
    stylisPlugins: [prefixer, rtlPlugin],
});

const theme = createTheme({
    direction: 'rtl',
});

const CssTextField = withStyles({
    root: {
        '& label.Mui-focused': {
            color: '#D7DBEC',
        },

        '& .MuiOutlinedInput-root': {
            '& fieldset legend span': {
                marginRight: 0,
                whiteSpace: 'nowrap',
                padding: "0 !important",
                display: 'inline-block',
                lineHeight: 'normal',
            },
            '&:hover fieldset': {
                borderColor: '#EDEDED',
            },
            '& fieldset': {
                border: "1px solid rgba(0,0,0,0.12) !important",
                borderRadius: '8px',
            },
            '&.Mui-focused fieldset': {
                borderColor: 'var(--input-bg-color)',
                border: "1px solid #BBA57A !important",
            },
            '& .MuiSelect-select': {
                backgroundColor: 'transparent !important',
            },
            '& input': {
                backgroundColor: 'transparent !important'
            },
            '& fieldset legend': {
                maxWidth: '0.01px', // hide default cutout
            },
            '& .MuiOutlinedInput-root fieldset legend': {
                maxWidth: 0, // default, so no cutout
                transition: 'max-width 0.2s ease-out',
            },
            '&.Mui-focused fieldset legend, & fieldset.MuiOutlinedInput-notched legend': {
                maxWidth: '100%',
            },
            '& input:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 1000px transparent inset !important',
                WebkitTextFillColor: 'var(--primary-text-color) !important',
                backgroundColor: 'transparent !important',
                transition: 'background-color 5000s ease-in-out 0s',
            },
        },
        '& legend': {
            letterSpacing: -2.5,

        },
    },
})(TextField);

export default function CustomisedTextField({
    className,
    autoFocus,
    label,
    error,
    onChange,
    helperText,
    value,
    type,
    inputLabelProps,
    multiline,
    rows,
    name,
    id,
    color,
    onKeyDown,
    onBlur,
    ref,
    onMouseUp,
    onSelect,
    maxRows,
    minRows,
    defaultValue,
    disabled,
    placeholder,
    inputProps,
    required,
    autoComplete,
    text_En,
    onclick,
    icon,
    onFocus,
}: ITextField) {
    const [jsonFile, setJsonFile] = useState<IShellConfig>();
    const mode = useSelector((state: RootState) => state.theme) as 'light' | 'dark';

    useEffect(() => {
        fetch('/setting/shellConfig.json')
            .then((res) => res.json())
            .then((data) => setJsonFile(data));
    }, []);

    const themeColors = jsonFile?.[mode];
    const LabelValue = (label: string) => {
        return (
            <Box color={themeColors?.primaryColorLight} fontSize={'0.9rem'} fontWeight={'bold'}>
                {label}
            </Box>
        )
    }

    return (
        <CacheProvider value={cacheRtl}>
            <div dir={text_En === 'ENG' ? 'ltr' : 'rtl'}>
                <CssTextField
                    fullWidth
                    autoFocus={autoFocus}
                    label={LabelValue(label!)}
                    error={error}
                    onChange={onChange}
                    helperText={helperText}
                    value={value}
                    type={type}
                    multiline={multiline}
                    rows={rows}
                    name={name}
                    id={id}
                    onKeyDown={onKeyDown}
                    onBlur={onBlur}
                    ref={ref}
                    onMouseUp={onMouseUp}
                    onSelect={onSelect}
                    maxRows={maxRows}
                    minRows={minRows}
                    defaultValue={defaultValue}
                    disabled={disabled}
                    placeholder={placeholder}
                    inputProps={inputProps}
                    // required={required}
                    autoComplete={autoComplete}
                    onClick={onclick}
                    onFocus={onFocus}
                    className={
                        error
                            ? '!m-0 rounded-lg anjomanMaxFNRegular max-h-12'
                            : '!m-0 text-sm !shadow-none rounded-lg anjomanMaxFNRegular max-h-12'
                    }
                    style={{ width: '100%', backgroundColor: 'var(--input-bg-color)' }}
                    // InputLabelProps={{
                    //     className: 'primaryColorLight-100',

                    //     sx: {
                    //         fontSize: '0.9rem',
                    //         fontWeight: 'bold',
                    //         top: '0px',
                    //         color: themeColors?.primaryColorLight100,
                    //         "&.MuiOutlinedInput-notchedOutline": { fontSize: "0.9rem" }
                    //     },
                    //     ...inputLabelProps,
                    // }}
                    InputProps={{
                        style: {
                            textAlign: 'center',
                            height: '50px',
                            alignItems: 'center',

                        },
                        endAdornment: icon ? (
                            <InputAdornment position="start">{icon}</InputAdornment>
                        ) : null,
                    }}
                    sx={{
                        input: {
                            color: themeColors?.primaryColorLight900,
                            fontSize: '0.9rem !important',
                            fontFamily: 'anjomanMaxFNRegular !important',

                        },
                    }}
                />
            </div>
        </CacheProvider>
    );
}
